import React from 'react';
import { Button, Modal, Container, Row, Col } from 'react-bootstrap';

const ConfirmationModal = (props) => {
    return (
        <Modal show={props.show} onHide={props.toggleModal}>
            <Modal.Header closeButton >
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={{ whiteSpace: "pre", lineHeight: '0.75' }}>{props.message}</p>
                <div style= {{fontSize : 12, fontWeight : "normal", fontStyle : "italic"}}>{props.subMessage}</div>
            </Modal.Body>

            <Modal.Footer>
                {props.modalButtons.map((button, i) => {
                    return <Button variant={button.variant} onClick={button.onClick} key={`mbutton-${i}`}>{button.label}</Button>
                })}
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal;